import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    updatePhonecallShouldSummarize as updatePhonecallShouldSummarizeMutation,
    updatePhonecallShouldSummarizeVariables,
    PhoneCallSetShouldSummarizeInput,
} from 'nutshell-graphql-types';

import UPDATE_PHONECALL_SHOULD_SUMMARIZE from '../mutations/update-phonecall-should-summarize.graphql';

export const useUpdatePhonecallShouldSummarize = (): {
    updatePhonecallShouldSummarize: (arg1: PhoneCallSetShouldSummarizeInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updatePhonecallShouldSummarize, {loading, error}] = useMutation<
        updatePhonecallShouldSummarizeMutation,
        updatePhonecallShouldSummarizeVariables
    >(UPDATE_PHONECALL_SHOULD_SUMMARIZE);

    return {
        updatePhonecallShouldSummarize: (input: PhoneCallSetShouldSummarizeInput) =>
            updatePhonecallShouldSummarize({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
